<template>
  <div id="app-head">
    <div class="head-box">
      <div class="head-left">
        <router-link to="/">
          <img src="../../../assets/images/logo.png" alt />
        </router-link>
        <img class="t-img" src="../../../assets/images/text.png" alt />
      </div>
      <div class="head-right">
        <i class="iconfont">&#xe624; 咨询热线 ：</i>
        <h3>{{webInfo.website_phone}}</h3>
        <p>{{webInfo.work_time?webInfo.work_time:'周一至周五 9:00-18:00'}}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      webInfo: {}
    };
  },
  computed: {
    webData() {
      let info = this.$store.state.web_info;
      return info;
    }
  },
  watch: {
    webData: {
      handler(val) {
        if (val) {
          this.webInfo = val;
        }
      },
      immediate:true,
    }
  }
};
</script>

<style lang="scss" scoped>
#app-head {
  width: 100%;
  height: 105px;
  background-color: #ffffff;
}
.head-box {
  max-width: 1300px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .head-left {
    padding: 9px 0;
    > a {
      > img {
        width: 134px;
        height: 80px;
      }
    }
    .t-img {
      width: 122px;
      height: 47px;
      margin: 18px 42px;
    }
  }
  .head-right {
    padding-left: 120px;
    position: relative;
    margin: 27px 0;
    > i {
      font-size: 18px;
      color: #c30d23;
      font-style: normal;
      position: absolute;
      top: 40%;
      left: 0;
      transform: translateY(-50%);
    }
    > h3 {
      font-size: 26px;
      color: #c30d23;
      font-weight: normal;
    }
    > p {
      font-size: 15px;
      color: #999999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Hospital/public/head.vue